export const getParentPageSlugFromSlug = (slug: string) => {
    const index = slug.lastIndexOf('/');

    if (index === -1) return '';

    return slug.slice(0, index);
};

export const getCurrentPageNameFromSlug = (slug: string) => {
    const index = slug.lastIndexOf('/');

    if (index === -1) return slug;

    return slug.slice(index + 1);
};
